export const globalButtonsName = {
  refreshName: '',
  printName: '',
  newName: 'Nuevo',
  editName: '',
  assignName: '',
  deleteName: '',
  askName: '¿Confirmar?',
  cancelName: '',
  backName: '',
  saveName: '',
  updateName: ''
}
